import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeHtml',
})
export class HtmlSanitizerPipe implements PipeTransform {
    public constructor(private sanitizer: DomSanitizer) {}

    public transform(value: string, args?: string): SafeHtml {
        if (args === 'style') {
            return this.sanitizer.bypassSecurityTrustStyle(value);
        }
        if (args === 'srcUrl') {
            return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        }
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}



// WEBPACK FOOTER //
// ./src/shared/module/common/pipe/html-sanitizer.pipe.ts